module.exports = __webpack_public_path__ + "img/beeldschermbril-stoel.fa29e4aa.svg";